module.exports = __webpack_public_path__ + "assets/views/01_aboutPadcev/unmet_needs_icons_ru.png";